import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { useEffect } from "react";
import { AtividadeObra } from "../../../../domain/models/atividade_obra";
import { AtividadeObraForm, AtividadeObraSchema } from "../../../schemas/Obras_informacoesgerais/atividade_obra";
import { zodResolver } from "@hookform/resolvers/zod";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import { DefaultFormCheckBox } from "../../../../../../common/components/default_form_checkbox";

import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { AtividadeObraFuncionario } from "../../../../domain/models/atividade_obra_funcionario";

/**
 * AtividadeObraModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedAtividadeObra: AtividadeObra | null,
  responsavelDropdown: AtividadeObraFuncionario[],
  corresponsavelDropdown: AtividadeObraFuncionario[],
  onClose: () => void;
  onSubmit: (e: any) => void;
};

export const AtividadeObraModal = ({
  open,
  saving,
  loading,
  selectedAtividadeObra,
  responsavelDropdown,
  corresponsavelDropdown,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<AtividadeObraForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(AtividadeObraSchema),
  });

  const [preencherResponsavel, preencherCorresponsavel] = hookForm.watch(['preencherResponsavel', 'preencherCorresponsavel']);

  useEffect(() => {
    if (open) {
      if (selectedAtividadeObra) {
        hookForm.setValue('atividade', selectedAtividadeObra.descricao ?? '');
        hookForm.setValue('preencherResponsavel', selectedAtividadeObra.idFuncionarioResp === null);
        hookForm.setValue('idFuncionarioResponsavel', selectedAtividadeObra.idFuncionarioResp);
        hookForm.setValue('funcionarioResponsavel', selectedAtividadeObra.funcionarioResp);
        hookForm.setValue('preencherCorresponsavel', selectedAtividadeObra.idFuncionarioCoresp === null);
        hookForm.setValue('idFuncionarioCorresponsavel', selectedAtividadeObra.idFuncionarioCoresp);
        hookForm.setValue('funcionarioCorresponsavel', selectedAtividadeObra.funcionarioCoresp);
      } else {
        hookForm.reset({
          preencherResponsavel: false,
          preencherCorresponsavel: false,
        });
      }
    }
  }, [
    open,
    selectedAtividadeObra,
    hookForm,
  ]);

  useEffect(() => {
    if (!preencherResponsavel) {
      if (selectedAtividadeObra) {
        if (selectedAtividadeObra.idFuncionarioResp === null) {
          setTimeout(() => hookForm.setValue('funcionarioResponsavel',
            selectedAtividadeObra.funcionarioResp), 0);
          return;
        }
      }
      setTimeout(() => hookForm.setValue('funcionarioResponsavel', ''), 0);
    }
  }, [
    selectedAtividadeObra,
    hookForm,
    preencherResponsavel,
  ]);

  useEffect(() => {
    if (!preencherCorresponsavel) {
      if (selectedAtividadeObra) {
        if (selectedAtividadeObra.idFuncionarioCoresp === null) {
          setTimeout(() => hookForm.setValue('funcionarioCorresponsavel',
            selectedAtividadeObra.funcionarioCoresp), 0);
          return;
        }
      }
      setTimeout(() => hookForm.setValue('funcionarioCorresponsavel', ''), 0);
    }
  }, [
    selectedAtividadeObra,
    hookForm,
    preencherCorresponsavel,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title={'Atividade Obra'}
      width='90rem'
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title={"Informações"} arrangement="fullRow">
        <>
          <DefaultFormInput
            name='atividade'
            label='Atividade'
            multiline={true}
            rows={4}
            required={true}
            reactHookForm={hookForm} />

          <div>
            {
              preencherResponsavel ?
                (
                  <DefaultFormInput
                    name='funcionarioResponsavel'
                    label='Responsável'
                    reactHookForm={hookForm}
                  />
                ) : (
                  <DefaultFormAutocomplete
                    name='idFuncionarioResponsavel'
                    label='Responsável'
                    options={responsavelDropdown}
                    getOptionKey={x => x.idFuncionario}
                    getOptionLabel={x => x.nome}
                    reactHookForm={hookForm}
                  />
                )
            }

            <DefaultFormCheckBox
              name='preencherResponsavel'
              label='Preencher'
              reactHookForm={hookForm}
            />

          </div>

          <div>
            <div>
              {
                preencherCorresponsavel ?
                  (
                    <DefaultFormInput
                      name='funcionarioCorresponsavel'
                      label='Corresponsável'
                      reactHookForm={hookForm}
                    />
                  ) : (
                    <DefaultFormAutocomplete
                      name='idFuncionarioCorresponsavel'
                      label='Corresponsável'
                      options={corresponsavelDropdown}
                      getOptionKey={x => x.idFuncionario}
                      getOptionLabel={x => x.nome}
                      reactHookForm={hookForm}
                    />
                  )
              }
            </div>

            <DefaultFormCheckBox
              name='preencherCorresponsavel'
              label='Preencher'
              reactHookForm={hookForm}
            />
          </div>
        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}